import ProductDetail from "./productDetails.container";

export default ProductDetail;
